import { required, email } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import gql from 'graphql-tag'

export default {
  name: 'ModalExportFile',
  data () {
    return {
      isLoading: false,
      file: '',
      labelButton: 'Importar arquivo',
      importing: false,
      email: null,
      error: '',
      fileExport: {}
    }
  },

  computed: {
    ...mapState({
      isVisibleModalExport: ({ modal }) => modal.isVisibleModalExport,
      loading: ({ importFile }) => importFile.loading,
      filter: ({ people }) => people.filter,
      campaignId: ({ campaign }) => campaign.campaign.id
    })
  },

  methods: {
    toggle () {
      this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL_EXPORT', false)
      this.provider = ''
      this.file = ''
      this.labelButton = 'Importar arquivo'
    },

    exportFiles (email) {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.filter.campaignId = Number(this.campaignId)
        this.fileExport = { email, ...this.filter }
        this.export(this.fileExport)
      }
    },

    export (params = {}) {
      this.isLoading = true
      this.$api.mutate({
        mutation: gql`mutation export (
          $email: String!
          $campaignId: ID
          $name: String
          $nameOrDocumentNumber: String
          $id: ID
          $status: String
          $periodBy: String
          $dateStart: ISO8601Date
          $dateEnd: ISO8601Date
        ) {
          export (
            email: $email
            campaignId: $campaignId
            name: $name
            nameOrDocumentNumber: $nameOrDocumentNumber
            id: $id
            status: $status
            periodBy: $periodBy
            dateStart: $dateStart
            dateEnd: $dateEnd
          ) {
            result {
              json
              status
            }
          }
        }`,
        variables: params,
      }).then(res => {
        this.$store.commit('statusBar/TOGGLE_STATUS_BAR', true)
        this.$store.commit('statusBar/SET_TYPE_BAR', 'info')
        this.$store.commit('statusBar/SET_TITLE_BAR', 'Exportação em andamento - Isso pode demorar alguns minutos!')
        setTimeout( () => {
          this.$store.commit('statusBar/TOGGLE_STATUS_BAR', false)
        }, 8000)
        this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL_EXPORT', false)
        this.isLoading = false
      }).catch(e => {
        this.$store.commit('statusBar/TOGGLE_STATUS_BAR', true)
        this.$store.commit('statusBar/SET_TYPE_BAR', 'error')
        this.$store.commit('statusBar/SET_TITLE_BAR', 'Falha na exportação!')
        setTimeout( () => {
          this.$store.commit('statusBar/TOGGLE_STATUS_BAR', false)
        }, 8000)
        this.$store.commit('modal/TOGGLE_VISIBILITY_MODAL_EXPORT', false)
        this.isLoading = false
      })
    },

    formatDate (d) {
      const date = new Date(d)
      let year = date.getFullYear()
      let month = date.getMonth()+1
      let day = date.getDate()

      if ( day < 10 ) { day = '0' + day}
      if ( month < 10 ) { month = '0' + month }

      const dateFormat = `${day}/${month}/${year}`

      return dateFormat
    }
  },

  validations: {
    email: {
      required,
      email
    }
  }
}
